module.exports = __webpack_public_path__ + "static/img/scholarship1.1a9cce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/scholarship1.png
// module id = c4uQ
// module chunks = 1